// extracted by mini-css-extract-plugin
export default {"cls1":"gOnpZB_ZShTt4PITJ5JD","cls2":"_WSUcbywewQ6F2oCcNEL gOnpZB_ZShTt4PITJ5JD"};